import * as firebase from "firebase/app";
import "firebase/analytics";
import "firebase/firestore";
import "firebase/functions";
import "firebase/auth";
import store from "@/store";
import router from "@/router";

firebase.analytics();

export const db = firebase.firestore();

export const functions = firebase.functions();
if (process.env.VUE_APP_EMULATED_FIREBASE) {
  if (window.location.hostname === "localhost") {
    if (process.env.VUE_APP_FIRESTORE_HOST) {
      db.settings({
        host: process.env.VUE_APP_FIRESTORE_HOST,
        ssl: false,
      });
    }
    if (process.env.VUE_APP_FUNCTIONS_HOST) {
      functions.useFunctionsEmulator(process.env.VUE_APP_FUNCTIONS_HOST);
    }
  }
}

export const auth = firebase.auth();
auth.onAuthStateChanged(user => {
  store.commit("changeLoginState", user);
  if (user) {
    if (router.currentRoute.params.nextUrl != null) {
      router.push(router.currentRoute.params.nextUrl);
    }
  }
});

export const loginGoogle = async function() {
  const provider = new firebase.auth.GoogleAuthProvider();
  firebase
    .auth()
    .signInWithPopup(provider)
    .catch(function(error) {
      const errorCode = error.code;
      const errorMessage = error.message;
      const email = error.email;
      const credential = error.credential;
      console.log(errorCode, errorMessage, email, credential);
    });
};

export const logout = async function() {
  firebase
    .auth()
    .signOut()
    .catch(function(error) {
      console.log(error);
    });
};
